import OptimizedImage from "./OptimizedImage";

//moment
import moment from "moment";

//icons
import PushPinIcon from "@mui/icons-material/PushPin";
import CommentIcon from "@mui/icons-material/Comment";

require("moment/locale/it"); // Carica la localizzazione italiana per moment

function ArticleCard(props) {
  function handleOnClick() {
    if (props.onClick) {
      props.onClick(props.article.id);
    }
  }

  return (
    <div id="article-card">
      <div className="card-overlay" />
      <OptimizedImage
        src={props?.article?.image?.media}
        className="card-image"
        alt={props.article?.title || "Immagine articolo"}
        width={400}
        height={300}
        loading="lazy"
        style={{
          objectFit: "cover",
          width: "100%",
          height: "100%",
          aspectRatio: "4/3",
        }}
      />
      <div className="article-title">{props.article?.title}</div>
      <div className="card-container">
        <p className="article-preview">
          {props.article?.description.length > 150
            ? props.article?.description.slice(0, 150) + "..."
            : props.article?.description}
        </p>
        <button onClick={handleOnClick.bind(this)}>Leggi di piú</button>
      </div>
      <div className="date-container">
        <div className="d-flex align-items-center">
          {props.article?.pinned && <PushPinIcon style={{ width: "20px" }} />}
          <div className="text-capitalize">
            {props.article?.date &&
              moment(
                props.article.date.seconds * 1000 +
                  Math.round(props.article.date.nanoseconds / 1e6)
              ).format("DD MMMM YYYY")}
          </div>
        </div>
        <div className="category">{props.article?.category}</div>
      </div>
      <div className="like-comments-container">
        <div className="counter">
          <CommentIcon className="like-icon" />
          <span>
            {
              props.article.comments.filter((comment) => comment.published)
                .length
            }
          </span>
        </div>
      </div>
    </div>
  );
}

export default ArticleCard;
